import { PrimaryButton } from "@shared/buttons";
import { Select } from "@shared/selects";
import { TextInput } from "@shared/text-input";

import { type SortingOption } from "../../context";

interface Props {
  search: string;
  sorting: SortingOption;
  onChangeSearch: (value: string) => void;
  onChangeSorting: (value: SortingOption) => void;
  onClickAddBreakdown: () => void;
}

export const Toolbar = ({
  search,
  sorting,
  onChangeSearch,
  onChangeSorting,
  onClickAddBreakdown,
}: Props) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <TextInput
          className="shrink-0"
          inputClassName="pl-8"
          width="400px"
          placeholder="Search breakdown names..."
          leftIcon={
            <i className="fa-regular fa-sharp fa-search text-gray text-sm" />
          }
          value={search}
          onChange={(e) => onChangeSearch(e.target.value)}
        />
        <Select
          width="180px"
          value={sorting}
          options={[
            { value: "updatedAt", label: "Sort by last updated" },
            { value: "name", label: "Sort A - Z" },
          ]}
          onChange={onChangeSorting}
        />
      </div>
      <PrimaryButton
        onClick={() => onClickAddBreakdown()}
        className="font-bold flex items-center gap-2.5"
      >
        <i className="fa-regular fa-circle-plus text-base" />
        ADD BREAKDOWN
      </PrimaryButton>
    </div>
  );
};
